export const zh = {
  "header": {
    "brand": "CikaStudio",
    "tools": "工具",
    "games": "游戏",
    "about": "关于"
  },
  "nav": {
    "tools": "工具",
    "games": "游戏",
    "about": "关于"
  },
  "actions": {
    "copy": "复制",
    "download": "下载",
    "clear": "清空",
    "copied": "已复制!",
    "copyAll": "复制全部",
    "downloadTxt": "下载 TXT",
    "generate": "生成",
    "regenerate": "重新生成",
    "format": "格式化",
    "minify": "压缩",
    "validate": "验证",
    "convert": "转换"
  },
  "footer": {
    "privacy": "隐私",
    "terms": "条款",
    "email": "联系我们",
    "moreTools": "更多工具",
    "copyright": "© {year} CikaStudio. 保留所有权利。"
  },
  "language": {
    "en": "English",
    "zh": "中文"
  },
  "theme": {
    "light": "浅色",
    "dark": "深色"
  },
  "common": {
    "clientSide": "100% 客户端处理",
    "noUpload": "不上传数据",
    "noAccount": "无需账号",
    "loading": "加载中...",
    "error": "错误",
    "success": "成功"
  },
  "randomNumber": {
    "title": "随机数生成器",
    "subtitle": "生成随机数。整数、小数、十六进制、二进制。",
    "privacy": "100% 本地处理",
    "type": "类型",
    "integer": "整数",
    "decimal": "小数",
    "hex": "十六进制",
    "binary": "二进制",
    "min": "最小值",
    "max": "最大值",
    "count": "数量",
    "maxCount": "最多 10,000",
    "settings": "设置",
    "unique": "仅唯一值",
    "sort": "排序",
    "none": "不排序",
    "asc": "升序",
    "desc": "降序",
    "generate": "生成",
    "invalid": "请输入有效的数字。最大值必须 ≥ 最小值，数量必须在 1-10,000 之间。",
    "results": "结果",
    "sum": "总和",
    "avg": "平均值",
    "minResult": "最小",
    "maxResult": "最大",
    "history": "历史记录"
  },
  "content": {
    "privacy": {
      "title": "隐私与安全",
      "description": "🔒 所有随机数生成均通过 Web Crypto API 在您的浏览器本地完成。您的设置和结果绝不会被传输。"
    },
    "guide": {
      "title": "如何使用随机数生成器",
      "description": "即时生成随机整数、小数、十六进制和二进制数字。",
      "steps": [
        {
          "title": "选择数字类型",
          "description": "根据您的使用场景，在整数、小数、十六进制或二进制输出格式之间进行选择。"
        },
        {
          "title": "设置范围和数量",
          "description": "定义最小值和最大值，并选择一批生成多少个数字。"
        },
        {
          "title": "复制结果",
          "description": "点击复制以保存单个数字或整个批次到剪贴板。对于较大的集合，可下载为文本文件。"
        }
      ]
    },
    "features": {
      "title": "核心功能",
      "items": [
        "多种输出格式：整数、小数、十六进制、二进制",
        "通过 Web Crypto API 提供加密级安全随机性",
        "可自定义最小/最大范围，适用于任何场景",
        "支持批量生成，最多可达数千个数字",
        "一键复制，可下载为文本文件",
        "100% 客户端处理 — 零数据上传"
      ]
    },
    "faq": {
      "title": "常见问题",
      "items": [
        {
          "question": "我的数据会被发送到服务器吗？",
          "answer": "不会。所有随机数均使用浏览器的 Web Crypto API 本地生成。没有任何内容被传输或外部存储。"
        },
        {
          "question": "这些数字是真正随机的吗？",
          "answer": "是的。Web Crypto API 提供加密级安全随机性，适用于安全令牌、模拟和统计抽样。"
        },
        {
          "question": "最大批量大小是多少？",
          "answer": "单次批次最多可生成 10,000 个数字。更大的集合可能受浏览器内存限制，但可以通过多个批次生成。"
        }
      ]
    },
    "related": {
      "title": "相关工具",
      "tools": [
        {
          "name": "UUID 生成器",
          "url": "/generator/uuid-generator",
          "description": "为 API 和数据库生成通用唯一标识符。"
        },
        {
          "name": "密码生成器",
          "url": "/generator/password-generator",
          "description": "生成强安全密码和易记的密码短语。"
        },
        {
          "name": "哈希生成器",
          "url": "/utility/hash-generator",
          "description": "生成 MD5、SHA-256 等加密哈希值。"
        }
      ]
    }
  }
};
